import { ComponentProps } from "react";
import "./request-under-process.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../../utils/translation";

export type RequestUnderProcessProps = ComponentProps<"div">;

export function RequestUnderProcess({ ...props }: RequestUnderProcessProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  return (
    <div className="request-under-process-modal modal-content" {...props}>
      <div className="top-area">
        <div className="title">
          {checkTranslationKey(translations[lang]?.Thank_you, "Thank you!")}
        </div>
        <div className="message-icon">
          <img src="../img/icns/under-process.png" alt="" width="80em" />
        </div>
        <div className="message">
          {checkTranslationKey(
            translations[lang]?.Your_request_is_under_process,
            "Your request is under process."
          )}
        </div>
      </div>
    </div>
  );
}

export default RequestUnderProcess;
